declare namespace $ {

	type $bog_merchquarium_carousel__ids_bog_merchquarium_product_card_1 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['photo_ids'] >
		,
		ReturnType< $bog_merchquarium_carousel['ids'] >
	>
	type $bog_merchquarium_carousel__url_bog_merchquarium_product_card_2 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['photo_url'] >
		,
		ReturnType< $bog_merchquarium_carousel['url'] >
	>
	type $mol_view__sub_bog_merchquarium_product_card_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_merchquarium_product_card_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_minor__hint_bog_merchquarium_product_card_5 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['share_hint'] >
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_merchquarium_product_card_6 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['share'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_merchquarium_product_card_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_merchquarium_product_card_8 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['cover'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_string_button__value_bog_merchquarium_product_card_9 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['title'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $mol_string_button__hint_bog_merchquarium_product_card_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string_button['hint'] >
	>
	type $mol_string_button__enabled_bog_merchquarium_product_card_11 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['changed'] >
		,
		ReturnType< $mol_string_button['enabled'] >
	>
	type $bog_merchquarium_number__value_min_bog_merchquarium_product_card_12 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_merchquarium_number['value_min'] >
	>
	type $bog_merchquarium_number__hint_bog_merchquarium_product_card_13 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_merchquarium_number['hint'] >
	>
	type $bog_merchquarium_number__value_bog_merchquarium_product_card_14 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['price'] >
		,
		ReturnType< $bog_merchquarium_number['value'] >
	>
	type $bog_merchquarium_number__enabled_bog_merchquarium_product_card_15 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['changed'] >
		,
		ReturnType< $bog_merchquarium_number['enabled'] >
	>
	type $mol_paragraph__title_bog_merchquarium_product_card_16 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['price_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_string_button__value_bog_merchquarium_product_card_17 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['description'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $mol_string_button__hint_bog_merchquarium_product_card_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string_button['hint'] >
	>
	type $mol_string_button__enabled_bog_merchquarium_product_card_19 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['changed'] >
		,
		ReturnType< $mol_string_button['enabled'] >
	>
	type $mol_paragraph__title_bog_merchquarium_product_card_20 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['description'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_select__options_bog_merchquarium_product_card_21 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['category_list'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__option_label_default_bog_merchquarium_product_card_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_select['option_label_default'] >
	>
	type $mol_select__enabled_bog_merchquarium_product_card_23 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['changed'] >
		,
		ReturnType< $mol_select['enabled'] >
	>
	type $mol_select__value_bog_merchquarium_product_card_24 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['category'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select_list__value_bog_merchquarium_product_card_25 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['fandoms'] >
		,
		ReturnType< $mol_select_list['value'] >
	>
	type $mol_select_list__dictionary_bog_merchquarium_product_card_26 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['fandom_dictionary'] >
		,
		ReturnType< $mol_select_list['dictionary'] >
	>
	type $mol_select_list__pick_hint_bog_merchquarium_product_card_27 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_select_list['pick_hint'] >
	>
	type $mol_select_list__enabled_bog_merchquarium_product_card_28 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['changed'] >
		,
		ReturnType< $mol_select_list['enabled'] >
	>
	type $mol_view__sub_bog_merchquarium_product_card_29 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['tags'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_bog_merchquarium_product_card_30 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['info_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_button_major__title_bog_merchquarium_product_card_31 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_merchquarium_product_card_32 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['cart_add'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__enabled_bog_merchquarium_product_card_33 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['cart_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $bog_merchquarium_counter__value_bog_merchquarium_product_card_34 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['cart_count'] >
		,
		ReturnType< $bog_merchquarium_counter['value'] >
	>
	type $mol_button_minor__title_bog_merchquarium_product_card_35 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['want_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_merchquarium_product_card_36 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['want'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__enabled_bog_merchquarium_product_card_37 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['want_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_view__sub_bog_merchquarium_product_card_38 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['cart_controls'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_open__files_bog_merchquarium_product_card_39 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['photos_add'] >
		,
		ReturnType< $mol_button_open['files'] >
	>
	type $mol_button_open__enabled_bog_merchquarium_product_card_40 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['changed'] >
		,
		ReturnType< $mol_button_open['enabled'] >
	>
	type $mol_button_open__accept_bog_merchquarium_product_card_41 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_open['accept'] >
	>
	type $mol_button_minor__title_bog_merchquarium_product_card_42 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_merchquarium_product_card_43 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['photo_delete'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__enabled_bog_merchquarium_product_card_44 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['photo_delete_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_switch__value_bog_merchquarium_product_card_45 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['status'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_bog_merchquarium_product_card_46 = $mol_type_enforce<
		({ 
			'available': string,
			'sold': string,
			'hidden': string,
		}) 
		,
		ReturnType< $mol_switch['options'] >
	>
	type $mol_switch__enabled_bog_merchquarium_product_card_47 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['changed'] >
		,
		ReturnType< $mol_switch['enabled'] >
	>
	type $mol_button_minor__title_bog_merchquarium_product_card_48 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_merchquarium_product_card_49 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['product_delete'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_row__sub_bog_merchquarium_product_card_50 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_button_minor__title_bog_merchquarium_product_card_51 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['tag_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_merchquarium_product_card_52 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_product_card['tag_select'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	export class $bog_merchquarium_product_card extends $mol_card {
		tag_title( id: any): string
		tag_select( id: any, next?: any ): any
		status( next?: string ): string
		photo_ids( ): readonly(string)[]
		photo_url( id: any): string
		Photos( ): $bog_merchquarium_carousel
		Photo_empty_icon( ): $mol_icon_image_off
		Photo_empty( ): $mol_view
		Sold_badge( ): $mol_paragraph
		share_hint( ): string
		share( next?: any ): any
		share_icon( ): $mol_icon_share_variant
		Share( ): $mol_button_minor
		cover( ): readonly(any)[]
		Cover( ): $mol_view
		title( next?: string ): string
		changed( ): boolean
		Title( ): $mol_string_button
		price( next?: any ): any
		Price( ): $bog_merchquarium_number
		price_text( ): string
		Price_text( ): $mol_paragraph
		description( ): string
		Description( ): $mol_string_button
		Description_text( ): $mol_paragraph
		category_list( ): readonly(any)[]
		category( next?: any ): any
		Category( ): $mol_select
		fandoms( next?: readonly(string)[] ): readonly(string)[]
		fandom_dictionary( ): Record<string, any>
		Fandoms( ): $mol_select_list
		tags( ): readonly(any)[]
		Tags( ): $mol_view
		info_rows( ): readonly(any)[]
		Info( ): $mol_list
		cart_add( next?: any ): any
		cart_enabled( ): boolean
		Cart_add( ): $mol_button_major
		Cart_counter( ): $bog_merchquarium_counter
		want_title( ): string
		want( next?: any ): any
		want_enabled( ): boolean
		Want( ): $mol_button_minor
		cart_controls( ): readonly(any)[]
		Cart_controls( ): $mol_view
		photos_add( next?: readonly(File)[] ): readonly(File)[]
		Photos_add( ): $mol_button_open
		photo_delete( next?: any ): any
		photo_delete_enabled( ): boolean
		Photos_delete( ): $mol_button_minor
		Status( ): $mol_switch
		product_delete( next?: any ): any
		Delete( ): $mol_button_minor
		Admin( ): $mol_row
		product_link( next?: string ): string
		catalog_link( next?: string ): string
		search( next?: string ): string
		cart_count( next?: number ): number
		editable( ): boolean
		Want_message( ): string
		Want_title( ): string
		Want_copied_title( ): string
		Share_copied_hint( ): string
		Share_done_icon( ): $mol_icon_check
		Tag( id: any): $mol_button_minor
		attr( ): ({ 
			'bog_merchquarium_product_card_state': ReturnType< $bog_merchquarium_product_card['status'] >,
		})  & ReturnType< $mol_card['attr'] >
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=card.view.tree.d.ts.map